module.exports = __webpack_public_path__ + "static/customer-dispute-management@3x-cbd0f70db9d5318db36ff92094b7d87f.png";